<template>
    <section class="w-full px-8 py-8 h-full">
        <div class="flex justify-between">
            <p class="dark:text-gray-200 text-gray-700 text-2xl tracking-widest uppercase">Recolha</p>
            <button @click="router.go(-1)" class="btn rounded-md dark:text-gray-200 ">Voltar para loja</button>
        </div>
        <div v-if="hasRecolha" id="header-loja" class="w-full md:w-4/5 mx-auto justify-around mt-4 flex px-8 py-8">
            <div class="flex flex-col gap-y-2">
                <div >
                    <p class="text-xs text-gray-500 dark:text-gray-200 uppercase">Loja</p>
                    <p class="text-indigo-500 dark:text-indigo-200">{{recolha.recolha.loja}}</p>
                </div>
                <div >
                    <p class="text-xs text-gray-500 dark:text-gray-200 uppercase">Realizada em</p>
                    <p class="text-indigo-500 dark:text-indigo-100">{{dateMask(recolha.recolha.pesquisa_realizada_em)}}</p>
                </div>
                <div class="">
                    <p class="text-xs text-gray-500 dark:text-gray-200 uppercase">Ano mês</p>
                    <p class="text-indigo-500 dark:text-indigo-300">{{recolha.recolha.ano_mes.slice(0,4)+'/'+recolha.recolha.ano_mes.slice(4,6)}}</p>
                </div>
                <div >
                    <p class="text-xs text-gray-500 dark:text-gray-200 uppercase">Status</p>
                    <p :class="recolha.recolha.editavel === 'false' ? 'text-green-500 dark:text-green-300' : 'text-yellow-300'">{{recolha.recolha.editavel === 'false' ? 'Finalizada' : 'Em progresso'}}</p>
                </div>
            </div>
            <div>
                <p class="text-xs text-gray-500 dark:text-gray-200 uppercase">por:</p>
                <div class="w-min">
                    <div class="bg-indigo-500 rounded-full w-24 h-24 mx-auto">
                        <img v-if="recolha.recolha.pesquisador.avatar" class="rounded-full " :src="recolha.recolha.pesquisador.avatar" alt="">
                        <span v-else class="h-full w-full flex"><p class="m-auto text-4xl text-gray-100">{{recolha.recolha.pesquisador.nome[0]}}{{recolha.recolha.pesquisador.nome.split(' ')[1][0]}}</p></span>
                    </div>
                    <p class="text-gray-500 dark:text-gray-100 whitespace-nowrap">{{recolha.recolha.pesquisador.nome}}</p>
                </div>
            </div>
        </div>
        <div class="">
            <Preencher @changeStatus="recolha.recolha.editavel = 'false'" :_recolha="recolha"/>
        </div>
    </section>
</template>

<script>
import { onMounted, ref } from '@vue/runtime-core'
import { GET_RECOLHA_RECOLHA_BY_ANOMES } from '../../mixins/api'
import { useRoute, useRouter } from 'vue-router'
import { dateTimeFormat } from '../../mixins/mask'
import { useStore } from 'vuex'
import Preencher from './PreencherRecolha.vue'

export default {
    name: 'DetalhesRecolhas',
    components: {
        Preencher
    },
    setup () {
        const router = useRouter()
        const route = useRoute()
        const store = useStore()

        const teste = ref(false)

        const editRecolha = ref(false)

        const userViewer = store.getters['auth/user']

        const recolha = ref({})
        const recolhaCopy = ref({})
        const hasRecolha = ref(false)

        const dateMask = dateTimeFormat

        onMounted(async () => {
            await GET_RECOLHA_RECOLHA_BY_ANOMES(route.params.id, route.params.anomes).then(r => {
                recolha.value = r.data.resultado
                recolhaCopy.value = r.data.resultado
                hasRecolha.value = true
            })
        })

        return {
            recolha,
            router,
            hasRecolha,
            store,
            editRecolha,
            userViewer,
            dateMask,
            teste
        }
    }
}
</script>
